import { post, get, downloadBlob } from './client';
import { makeGrowerPath } from './utils';

export function runNRx(aaids, nRxProps) {
  return post(makeGrowerPath(`/nrx/run`), { aaids, ...nRxProps }).then(
    (response) => response.map((job) => ({ job })),
  );
}

export function getNrxForGrower(growerId) {
  return get(`/nrx/by-grower/${growerId}`);
}

export function getNrxStats(aaid) {
  return get(makeGrowerPath(`/nrx/stats/${aaid}/nrx`));
}

export function setNrxAdjustmentFactor(aaid, adjustmentFactor) {
  return post(makeGrowerPath(`/nrx/adjustment-factor/${aaid}`), {
    adjustmentFactor,
  });
}

export function setNrxGroupAdjustment(aaid, groupAdjustments) {
  return post(
    makeGrowerPath(`/nrx/group-adjustment/${aaid}`),
    groupAdjustments,
  );
}

export function getNrxGroupAdjustment(aaid) {
  return get(makeGrowerPath(`/nrx/group-adjustment/${aaid}`));
}

export function downloadNrxShapefile(growerId, aaids) {
  return downloadBlob(`/n/${growerId}/shapefile`, aaids);
}

export function downloadNrxPdfs(growerId, aaids) {
  return downloadBlob(`/nrx/${growerId}/pdf`, aaids);
}
